module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qurin2-45a193096dd998368b694d1af0420e0e.jpg";